import { User, Copy, Calendar, MapPin, Target, Package } from 'lucide-react';

const InfoField = ({ label, value, onCopy }) => (
  <div>
    <p className="text-xs text-gray-400 uppercase mb-1">{label}</p>
    <p className="text-gray-900 flex items-center gap-2">
      {value || '-'}
      {value && onCopy && <button onClick={() => onCopy(value)}><Copy className="w-3.5 h-3.5 text-gray-400" /></button>}
    </p>
  </div>
);

const StatBox = ({ label, children }) => (
  <div className="bg-gray-50 rounded-lg p-4">
    <p className="text-xs text-gray-400 uppercase mb-1">{label}</p>
    {children}
  </div>
);

const ServiceTag = ({ text }) => (
  <span className="px-3 py-1.5 bg-[#014DB7]/10 text-[#014DB7] rounded-lg text-sm font-medium">{text}</span>
);

export function OverviewTab({ client, fullName, copy, fmtDate }) {
  const tags = client.service_tags || [];
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <h3 className="flex items-center gap-2 font-semibold text-gray-900 mb-6"><User className="w-4 h-4 text-amber-500" /> Contact Information</h3>
          <div className="space-y-5">
            <InfoField label="Full Name" value={fullName} />
            <div className="grid grid-cols-2 gap-4">
              <InfoField label="Email" value={client.email} onCopy={copy} />
              <InfoField label="Phone" value={client.phone} onCopy={copy} />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <InfoField label="Company" value={client.company_name} />
              <InfoField label="Job Title" value={client.job_title} />
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <h3 className="flex items-center gap-2 font-semibold text-gray-900 mb-6"><Target className="w-4 h-4 text-amber-500" /> Account Status</h3>
          <div className="grid grid-cols-2 gap-4">
            <StatBox label="Status"><span className="px-3 py-1 rounded-md text-xs font-semibold uppercase bg-green-100 text-green-700 border border-green-300">{client.status || 'active'}</span></StatBox>
            <StatBox label="Account Type"><p className="text-gray-900 font-medium">Client</p></StatBox>
          </div>
        </div>
      </div>
      {(client.address || client.city) && (
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <h3 className="flex items-center gap-2 font-semibold text-gray-900 mb-4"><MapPin className="w-4 h-4 text-amber-500" /> Address</h3>
          <p className="text-gray-700">{client.address}</p>
          <p className="text-gray-700">{client.city}{client.state ? `, ${client.state}` : ''} {client.zip_code}</p>
        </div>
      )}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h3 className="flex items-center gap-2 font-semibold text-gray-900 mb-6"><Calendar className="w-4 h-4 text-amber-500" /> Timeline</h3>
        <div className="grid grid-cols-3 gap-4">
          <StatBox label="Created"><p className="font-medium text-gray-900">{fmtDate(client.created_at)}</p></StatBox>
          <StatBox label="Last Updated"><p className="font-medium text-gray-900">{fmtDate(client.updated_at)}</p></StatBox>
          <StatBox label="Status"><span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700">{(client.status || 'active').toUpperCase()}</span></StatBox>
        </div>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h3 className="flex items-center gap-2 font-semibold text-gray-900 mb-4"><Package className="w-4 h-4 text-amber-500" /> Services</h3>
        {tags.length > 0 ? (
          <div className="flex flex-wrap gap-2">{tags.map((t, i) => <ServiceTag key={i} text={t} />)}</div>
        ) : (
          <p className="text-sm text-gray-400">No services assigned yet. Your provider will add services to your account.</p>
        )}
      </div>
    </div>
  );
}
